var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#18214D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6354 22.0938L25.8854 25.25C25.7916 25.7188 25.4166 26.0312 24.9479 26.0312C17.0729 26 10.6666 19.5938 10.6666 11.7188C10.6666 11.25 10.9479 10.875 11.4166 10.7812L14.5729 10.0312C15.0104 9.9375 15.4791 10.1875 15.6666 10.5938L17.1354 14C17.2916 14.4062 17.1979 14.875 16.8541 15.125L15.1666 16.5C16.2291 18.6562 17.9791 20.4062 20.1666 21.4688L21.5416 19.7812C21.7916 19.4688 22.2604 19.3438 22.6666 19.5L26.0729 20.9688C26.4791 21.1875 26.7291 21.6562 26.6354 22.0938Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCall);
export default __webpack_public_path__ + "static/media/ic_call.544f2cf612bf8b4f3b5c56325fe50e50.svg";
export { ForwardRef as ReactComponent };